import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
    imageWrapper: {
        aspectRatio: "1.65",
        position: "relative",
      },

    customCard: {
        width: "100%",
        height: '250px',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        textAlign: 'start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        // borderRadius: '10px',
        // paddingBottom:
      },
      cardContent: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '10px',
        borderRadius: '0 0 10px 10px',
        width: '100%',
        boxSizing: 'border-box',
      },

}))
export default useStyles;